import { create } from 'zustand';
import type { Density } from '@billda/shared-ui';

const getStoredDensity = (): Density => {
  const stored = localStorage.getItem('density');
  return stored === 'compact' || stored === 'comfortable'
    ? stored
    : 'comfortable';
};

const setStoredDensity = (density: Density) => {
  localStorage.setItem('density', density);
};

interface DensityState {
  density: Density;
  setDensity: (density: Density) => void;
  toggleDensity: () => void;
  initializeDensity: () => void;
}

export const useDensityStore = create<DensityState>((set, get) => ({
  density: 'comfortable',

  setDensity: (density: Density) => {
    set({ density });
    setStoredDensity(density);
  },

  toggleDensity: () => {
    const d = get().density;
    get().setDensity(d === 'comfortable' ? 'compact' : 'comfortable');
  },

  initializeDensity: () => {
    set({ density: getStoredDensity() });
  },
}));
